import { useMutation, useQueryClient } from '@tanstack/react-query';
import useFetchWithMsal from "../../../hooks/useFetchWithMsal";
import { protectedResources } from "../../../authConfig";
import { useToast } from "../../../contexts/ToastContext";

const usePriorityRetry = () => {
  const { execute } = useFetchWithMsal({
    scopes: protectedResources.apiScopes.scopes.write,
  });
  
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  const retryPriorityCreation = async (approvalPackageId) => {
    try {
      const response = await execute(
        "POST",
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/approvalPackages/retryPriorityCreation/${approvalPackageId}`
      );
      
      return response;
    } catch (error) {
      console.error('Error retrying priority creation:', error);
      throw error;
    }
  };

  const mutation = useMutation({
    mutationFn: retryPriorityCreation,
    onSuccess: (data) => {
      showToast(
        'בקשה לשליחה מחדש נקלטה בהצלחה', 
        "success"
      );

      setTimeout(() => {
        queryClient.invalidateQueries(['spInvoices']);
        queryClient.invalidateQueries(['approvalPackages']);
      }, 1000);
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message || 
                          error.message || 
                          "שגיאה בשליחה מחדש";
      showToast(errorMessage, "error");
      console.error('Priority retry error:', error);
    }
  });

  return {
    retryPriorityCreation: mutation.mutate,
    isRetrying: mutation.isPending,
    error: mutation.error
  };
};

export default usePriorityRetry;
